<template>
	<nk-page commercialAccess="System">
		<template #badges>
			<nk-badge system="accounting">
			</nk-badge>
		</template>
		<div class="nk-card form-container">
			<div class="col-12">
				<div class="row">
					<div class="col-12">
						<nk-col-form-group :label="$t('table.filter.start') + ':'" :labelAligns="{ xs: 'left' }" :labelSizes="{ xs: 2 }" :dataSizes="{ xs: 10 }">
							<nk-date v-if="settings.mode === 'date-filter-mode'" :options="componentOptions.date" v-model="settings.range.start" :tabindex="101"></nk-date>
							<nk-input v-else v-model="settings.range.start" :options="componentOptions.inputOption" :tabindex="101" startup></nk-input>
						</nk-col-form-group>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<nk-col-form-group :label="$t('table.filter.end') + ':'" :labelAligns="{ xs: 'left' }" :labelSizes="{ xs: 2 }" :dataSizes="{ xs: 10 }">
							<nk-date v-if="settings.mode === 'date-filter-mode'" :options="componentOptions.date" v-model="settings.range.end" :tabindex="102"></nk-date>
							<nk-input v-else v-model="settings.range.end" :options="componentOptions.inputOption" :tabindex="102" startup></nk-input>
						</nk-col-form-group>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script>
	import $sc from '~/plugins/shortcut.collection.js'
	import _ from 'lodash'

	export default {
		modal: {
			size: 'sm',
			stateUID: 'search-range',
		},
		props: {
			options: {}
		},
		mounted() {
			this.settings = _.merge({}, this.settings, this.options)
			this.prepareWindow(this.$t('table.filter.search-range'), [
				this.saveButton,
			])
		},
		data() {
			return {
				settings: {
					range: {},
					mode: 'number-filter-mode',
				},
				saveButton: {
					title: this.$t('select'),
					shortcut: $sc.find('save'),
					isPrimary: true,
					icon: 'check',
					handle: () => {
						this.save()
					},
				},
				componentOptions: {
					date: {
						pickerEnabled: true,
						pickerCss: 'btn btn-default',
					},
					inputOption: {
						mode: 'string',
					},
				}
			}
		},
		methods: {
			save() {
				if (this.settings.range.start && this.settings.range.start) this.resolve(this.settings.range)
				this.reject()
			}
		}
	}
</script>

<style></style>